var React = require('react');

function IconRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M258.8 853.4c-2.2 1.9-3.5 4.7-3.5 7.7v87.6c0 8.8 10.5 13.5 17.1 7.7l488.9-438.3c4.7-4.1 4.7-11.4 0-15.5L272.4 65.3c-6.7-5.9-17.1-1.1-17.1 7.7v88.7c0 2.9 1.3 5.7 3.5 7.7L638.5 511 258.8 853.4z"}));
}

IconRight.displayName = "IconRight";

IconRight.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconRight;

IconRight.default = IconRight;
